﻿import { GetConstraintsResponse } from '../../components/constraints-list/types';
import { httpGet } from './api';

async function fetchConstraints(): Promise<(GetConstraintsResponse & { responseCode: number }) | null> {
    return await httpGet<GetConstraintsResponse>('GetFAATFM');
}

export default {
    fetchConstraints
};
